import Vue from 'vue'
import Vuex from 'vuex'
import header from './modules/header'
import manageStudent from './modules/manageStudent'
import progessLesson from './modules/progessLesson'
import manageDetail from './modules/manageDetail'
import schoolBussiness from './modules/schoolBussiness'
import applyCourse from './modules/applyCourse'
import exam from './modules/exam'
import learn from './modules/learn'
import showFurigana from './modules/showFurigana'

Vue.use(Vuex);


const store = new Vuex.Store({
    modules: {
        header,
        manageStudent,
        progessLesson,
        manageDetail,
        schoolBussiness,
        exam,
        learn,
        showFurigana,
        applyCourse
    }
});
export default store;




// WEBPACK FOOTER //
// ./src/stores/index.js